// extracted by mini-css-extract-plugin
export default {"skills":"Skills_skills__hAdNh","content":"Skills_content__F1BZO","title":"Skills_title__VxwC3","skillsItems":"Skills_skillsItems__roWi7"};